import type { AgeSubcategory } from './individualEntry';

export type StartListTarget = 'TEAM' | 'INDIVIDUAL';

export interface StartListGroup {
  id: number;
  disciplineId: number;
  name: string;
  ageSubcategories?: AgeSubcategory[] | null;
  target: StartListTarget;
  parallelLanes: number;
  sortOrder: number;
}

export interface CreateStartListGroupRequest {
  name: string;
  ageSubcategories?: AgeSubcategory[] | null;
  target: StartListTarget;
  parallelLanes: number;
  sortOrder?: number;
}

export const START_LIST_TARGET_LABELS: Record<StartListTarget, string> = {
  TEAM: 'Družstva',
  INDIVIDUAL: 'Jednotlivci',
};

// ----- Vygenerovana startovka (Phase 3) -----

export interface StartListEntry {
  id: number;
  athleteId?: number | null;
  athleteName?: string | null;
  teamId?: number | null;
  teamName?: string | null;
  individualEntryId?: number | null;
  individualEntryName?: string | null;
  sdhUnitName?: string | null;
  heatNumber: number;
  laneNumber: number;
  startNumber?: number | null;
}

export interface Heat {
  heatNumber: number;
  /** Pole o delce parallelLanes; null = neobsazena draha. */
  lanes: Array<StartListEntry | null>;
}

export interface CollisionReport {
  heatNumber: number;
  teamId?: number | null;
  message: string;
}

export interface StartList {
  disciplineId: number;
  groupId: number;
  parallelLanes: number;
  heats: Heat[];
  unresolvedCollisions: CollisionReport[];
}

export interface ReorderStartListEntryRequest {
  heatNumber: number;
  laneNumber: number;
}
